import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable()
export class FacebookPixelService {
  designatedProjectIds: number[] = [2521, 946];
  constructor() {}

  checkIfDesignated(eventId: number): Observable<boolean> {
    return of(this.designatedProjectIds.includes(eventId));
  }
}
